<p-dialog
  header="{{ moveDialogContent.title | translate }}"
  [(visible)]="moveDialogContent.showMoveDialog"
  [style]="{ width: '90vw' }"
  [modal]="true"
  styleClass="{{ moveDialogContent.styleClass }}"
  [draggable]="false"
>
  <div class="w-full flex flex-1 h-full overflow-hidden">
    <div class="w-1/6 h-full bg-[--pho_white_shade1]">
      <p-tabView
        styleClass="move-tab-view"
        *ngIf="moveDialogContent?.tabDetails.length"
      >
        <ng-container *ngFor="let tab of moveDialogContent?.tabDetails">
          <p-tabPanel header="{{ tab.heading | translate }}">
            <ng-template pTemplate="header">
              <span (click)="dialogTabChange(tab.key)">{{ tab.heading | translate }}</span>
            </ng-template>
          </p-tabPanel>
        </ng-container>
      </p-tabView>
    </div>

    <div class="w-5/6 h-full">
      <div class="w-full h-full">
        <div class="flex w-full items-center justify-between mb-3 p-3.5 pb-0">
          <div class="breadcrumbs-folder">
            <ul class="flex items-center">
              <li
                *ngFor="
                  let breadCrumbs of getBreadcrumbList();
                  let i = index;
                  let lastIndex = last
                "
                (click)="!lastIndex ? navigateToFolderLink(breadCrumbs) : ''"
              >
                <ng-container>
                  {{ breadCrumbs.label | translate }}
                </ng-container>
              </li>
            </ul>
          </div>

          <div class="flex items-center gap-3">
            <div class="search-box flex">
              <input
                [(ngModel)]="searchText"
                (keyup)="filterSearch($any($event.target).value)"
                class="form-control"
                value=""
              [placeholder]="'SHARED.SEARCH' | translate"
            />
              <div class="icon-search">
                <img src="https://cdn.catexpert.ab-inbev.com/assets/images/icon-search.svg" />
              </div>
            </div>
            <app-button-primary
              *ngIf="showNewFolderButton"
              [buttonCaption]="'SHARED.NEW_FOLDER' | translate"
              buttonClassName="xs-medium"
              (actionButtonCall)="createNewFolderDialog()"
            ></app-button-primary>
          </div>
        </div>

        <div class="move-experiment-table">
          <app-experiment-list
            [tableColumns]="dialogTableColumns"
            [tableData]="experimentList"
            [skeletonLoader]="true"
            [dragDropDisabled]="true"
            [pageSize]="pageSize"
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [totalItems]="totalRecords"
            [statusOptions]="moveDialogContent?.experimentStatus"
            [moveDialogView]="true"
            (emitTableAction)="getTableAction($event)"
          ></app-experiment-list>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <app-button-secondary
        (actionButtonCall)="experimentsFoldersMoveAction(false)"
        buttonCaption="{{ moveDialogContent.btnCancel | translate }}"
        buttonClassName="xs-medium"
      ></app-button-secondary>
      <app-button-primary
        buttonCaption="{{ moveDialogContent.btnProceed | translate }}"
        (actionButtonCall)="experimentsFoldersMoveAction(true)"
        [buttonDisabled]="!isMoveButtonDisabled"
        buttonClassName="xs-medium"
      ></app-button-primary>
    </div>
  </ng-template>
</p-dialog>

<!-- New folder creation dialog -->
<app-new-folder-dialog
  *ngIf="newFolderDialogContent.showFolderDialog"
  [folderDialogContent]="newFolderDialogContent"
  (folderDialogActionCall)="folderDialogAction($event)"
></app-new-folder-dialog>
